// extracted by mini-css-extract-plugin
export default {"signupWrapper":"Signup_signupWrapper__NnbrP","signupContainer":"Signup_signupContainer__W0K+z","input":"Signup_input__5e5ns","button":"Signup_button__22PP5"};